import api from "../../../utils/axios-utils";

const cache = new Map<string, string>();

export async function getScreenshotUrl(
  sessionId: string,
  slideIdx: number | string,
): Promise<string | null> {
  const key = `${sessionId}:${slideIdx}`;
  const cached = cache.get(key);
  if (cached) return cached;

  try {
    const res = await api.get(
      `/analytics/sessions/${sessionId}/slides/${slideIdx}/screenshot`,
    );
    const url: string = res.data.url;
    cache.set(key, url);
    return url;
  } catch {
    return null;
  }
}
